export default $(()=>{

    let $search = $('#search');
    let $icon = $search.find('.fa-search');

    $search
        .find('input')
        .on('focusin', (self) => {
            $search.addClass('active');
        })
        .on('focusout', (self) => {
            $search.removeClass('active');
        });

    $icon
        .on('click', function(){
            if($search.hasClass('stuck')){
                window.location.href = '/';
            }
        });
});
